module.exports = __webpack_public_path__ + "static/media/registro.3e08d1e8.png";